import { ColumnDetails, ColumnType } from '../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { getExclusionItemTypeGridValues } from '../../../../utils/uiSettings/encryption/encryption.values';

export enum Column {
  TYPE = 1,
  ENTITY,
}

export enum ColumnKeys {
  TYPE = 'type',
  ENTITY = 'entity',
}

export const GRID_COLUMNS = [Column.TYPE, Column.ENTITY];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.ENUM,
      values: getExclusionItemTypeGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.ENTITY,
      key: ColumnKeys.ENTITY,
      columnName: translateFn('Excluded items'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
  ];
}
